import React from 'react';
import { useTranslations } from 'next-intl';
import { featureBookingModalConfig } from '@/shared/config/tests/e2e/features/booking';
import { classNames } from '@/shared/lib/classnames/classnames';
import type { ButtonVariants } from '@/shared/ui/button';
import { Button } from '@/shared/ui/button';
import { useBookingModals } from '../../model/store/bookingModals';
interface Props {
  btnClass?: string;
  btnVariants?: ButtonVariants;
  showModal?: () => void;
  modalId: number | 'all';
}
export const BookingTrigger: React.FC<Props> = props => {
  const {
    btnClass,
    modalId,
    showModal,
    btnVariants = {}
  } = props;
  const t = useTranslations();
  const {
    setVisibleBookingModal
  } = useBookingModals();
  const preShowModal = () => {
    if (typeof showModal === 'function') {
      showModal();
    }
    setVisibleBookingModal(true, modalId);
  };
  return <Button textWeight={btnVariants.textWeight || 'bold'} onClick={preShowModal} variant={btnVariants.variant || 'default'} size={btnVariants.size || 'default'} className={classNames('w-full touch-pan-y', {}, [btnClass])} data-testid={featureBookingModalConfig.ids.bookingTrigger} data-sentry-element="Button" data-sentry-component="BookingTrigger" data-sentry-source-file="BookingTrigger.tsx">
      {t('bookingPage.online_booking')}
    </Button>;
};